import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import PageLoader from '../PageLoader';
import { useTranslation } from 'react-i18next';

const Referearn = () => {
    const { t } = useTranslation();
    const { handleCallApi, setShowToast, setToastMsg, } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState("");

    const FetchRef = useRef(false);

    useEffect(() => {
        handleGetData();
    }, []);

    const handleGetData = async () => {
        if (FetchRef.current) return;
        FetchRef.current = true;
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/refer_and_earn", { uid });
        setData(Response.data.refer_data);
        setLoading(false);
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(data?.referral_code);
        setShowToast(true);
        setToastMsg('Referral code copied!');
    };

    const handleShare = (platform) => {
        const shareUrl = `${window.location.origin}/auth/login-signup?ref=${data?.referral_code}`;
        const shareText = `Hey! Join ZippyGo using my referral code ${data?.referral_code} and get ₹${data?.signup_credit} in your wallet! ${shareUrl}`;

        let url = '';
        const encodedText = encodeURIComponent(shareText);

        switch (platform) {
            case 'whatsapp':
                url = `https://wa.me/?text=${encodedText}`;
                break;
            case 'sms':
                url = `sms:?body=${encodedText}`;
                break;
            case 'share':
                if (navigator.share) {
                    navigator.share({
                        title: 'ZippyGo',
                        text: shareText,
                        url: shareUrl,
                    }).catch(() => { });
                    return;
                }
                break;
        }

        if (url) window.open(url, '_blank');
    }

    return (
        <div className="py-3">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">

                <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 rounded-full bg-[--bg-color] flex items-center justify-center">
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.5 6.25H18.4351C18.6291 5.873 18.75 5.452 18.75 5C18.75 3.484 17.517 2.25 16 2.25C15.178 2.25 14.405 2.61599 13.874 3.26099C13.847 3.29499 12.723 4.78898 12 5.75098C11.276 4.78798 10.151 3.29199 10.119 3.25299C9.59502 2.61499 8.822 2.25 8 2.25C6.483 2.25 5.25 3.484 5.25 5C5.25 5.452 5.36994 5.873 5.56494 6.25H4.5C3.26 6.25 2.25 7.259 2.25 8.5V12C2.25 12.414 2.586 12.75 3 12.75H3.25V18C3.25 20.418 4.582 21.75 7 21.75H17C19.418 21.75 20.75 20.418 20.75 18V12.75H21C21.414 12.75 21.75 12.414 21.75 12V8.5C21.75 7.259 20.74 6.25 19.5 6.25ZM20.25 8.5V11.25H12.75V7.75H16H19.5C19.913 7.75 20.25 8.086 20.25 8.5ZM15.0389 4.20697C15.2809 3.91297 15.622 3.75 16 3.75C16.689 3.75 17.25 4.311 17.25 5C17.25 5.689 16.689 6.25 16 6.25H13.502C14.177 5.352 14.9919 4.26797 15.0389 4.20697ZM6.75 5C6.75 4.311 7.311 3.75 8 3.75C8.378 3.75 8.719 3.91198 8.948 4.19098C9.003 4.26198 9.82105 5.35 10.498 6.25H8C7.311 6.25 6.75 5.689 6.75 5ZM3.75 8.5C3.75 8.086 4.087 7.75 4.5 7.75H8H11.25V11.25H3.75V8.5ZM4.75 18V12.75H11.25V20.25H7C5.423 20.25 4.75 19.577 4.75 18ZM19.25 18C19.25 19.577 18.577 20.25 17 20.25H12.75V12.75H19.25V18Z" fill="white" />
                        </svg>
                    </div>
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900">{t("Refer & Earn")}</h1>
                        <p className="text-gray-600 mt-1">{t("Share and earn rewards together!")}</p>
                    </div>
                </div>

                <div className="rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md mb-6">
                    <div className="p-6">
                        <h2 className="text-lg font-bold text-gray-900 mb-4">{t("Your Referral Code")}</h2>

                        <div className="bg-[#4038ff]/10 rounded-xl p-6 mb-4">
                            <p className="text-sm text-gray-800 mb-3 text-center">{t("Share this code with your friends")}</p>
                            <div className="flex flex-wrap items-center justify-center gap-3 mb-4">
                                <div className="bg-white px-8 py-4 rounded-lg border-2 border-dashed border-[--bg-color]">
                                    <span className="text-3xl font-bold text-[--bg-color] tracking-wider">
                                        {data?.referral_code}
                                    </span>
                                </div>
                                <button onClick={handleCopy} className="bg-[--bg-color] text-white px-[30px] py-[15px] rounded-[10px] font-bold italic tracking-[1px] flex items-center gap-3 active:scale-95 duration-200">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.375 6.25H9.625C7.448 6.25 6.25 7.448 6.25 9.625V18.375C6.25 20.552 7.448 21.75 9.625 21.75H18.375C20.552 21.75 21.75 20.552 21.75 18.375V9.625C21.75 7.448 20.552 6.25 18.375 6.25ZM20.25 18.375C20.25 19.707 19.707 20.25 18.375 20.25H9.625C8.293 20.25 7.75 19.707 7.75 18.375V9.625C7.75 8.293 8.293 7.75 9.625 7.75H18.375C19.707 7.75 20.25 8.293 20.25 9.625V18.375ZM3.75 5.62V14.38C3.75 15.578 4.23309 15.873 4.39209 15.971C4.74609 16.187 4.85589 16.649 4.63989 17.002C4.49789 17.233 4.25202 17.36 3.99902 17.36C3.86602 17.36 3.72991 17.324 3.60791 17.25C2.70691 16.698 2.25 15.733 2.25 14.38V5.62C2.25 3.478 3.47912 2.25 5.62012 2.25H14.3799C16.0649 2.25 16.87 2.98897 17.25 3.60797C17.466 3.96097 17.355 4.42298 17.002 4.63898C16.648 4.85598 16.1879 4.74399 15.9709 4.39099C15.8739 4.23199 15.5779 3.74902 14.3799 3.74902H5.62012C4.29212 3.75002 3.75 4.292 3.75 5.62Z" fill="currentColor" />
                                    </svg>
                                    {t("Copy")}
                                </button>
                            </div>
                            <div className="flex flex-wrap gap-3 justify-center">
                                <button onClick={() => handleShare('whatsapp')} className="border-2 border-green-500 text-green-600 hover:bg-white px-5 py-2 rounded-[10px] transition-colors flex items-center gap-2">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.0049 21.749C3.5479 21.749 3.10408 21.569 2.76809 21.233C2.29408 20.76 2.13108 20.073 2.34108 19.441L3.1819 16.94C3.2799 16.633 3.27102 16.325 3.15602 16.082C2.56402 14.809 2.25392 13.399 2.25392 11.999C2.25392 6.62402 6.62697 2.25 12.002 2.25C17.378 2.25 21.751 6.62302 21.751 11.999C21.751 17.375 17.378 21.748 12.002 21.748C10.603 21.748 9.19302 21.437 7.92702 20.848C7.67802 20.729 7.36902 20.721 7.05202 20.822L4.56301 21.658C4.37801 21.719 4.1899 21.749 4.0049 21.749ZM12.001 3.75C7.453 3.75 3.75295 7.45002 3.75295 11.999C3.75295 13.182 4.01596 14.373 4.51296 15.443C4.78896 16.024 4.82493 16.723 4.60793 17.406L3.76393 19.917C3.72193 20.042 3.7859 20.131 3.8279 20.173C3.8699 20.215 3.95998 20.279 4.08498 20.237L6.58303 19.398C7.27703 19.177 7.97796 19.211 8.56496 19.492C9.62696 19.986 10.818 20.249 12.001 20.249C16.55 20.249 20.25 16.549 20.25 12C20.25 7.451 16.55 3.75 12.001 3.75Z" fill="currentColor" />
                                    </svg>
                                    <span className="font-semibold">{t("WhatsApp")}</span>
                                </button>
                                <button onClick={() => handleShare('sms')} className="border-2 border-[--bg-color] text-[--bg-color] hover:bg-white px-5 py-2 rounded-[10px] transition-colors flex items-center gap-2">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16 21.75H8C5.582 21.75 4.25 20.418 4.25 18V6C4.25 3.582 5.582 2.25 8 2.25H16C18.418 2.25 19.75 3.582 19.75 6V18C19.75 20.418 18.418 21.75 16 21.75ZM8 3.75C6.423 3.75 5.75 4.423 5.75 6V18C5.75 19.577 6.423 20.25 8 20.25H16C17.577 20.25 18.25 19.577 18.25 18V6C18.25 4.423 17.577 3.75 16 3.75H8ZM14.25 6C14.25 5.586 13.914 5.25 13.5 5.25H10.5C10.086 5.25 9.75 5.586 9.75 6C9.75 6.414 10.086 6.75 10.5 6.75H13.5C13.914 6.75 14.25 6.414 14.25 6ZM12 17C11.448 17 11 17.448 11 18C11 18.552 11.448 19 12 19C12.552 19 13 18.552 13 18C13 17.448 12.552 17 12 17Z" fill="currentColor" />
                                    </svg>
                                    <span className="font-semibold">{t("SMS")}</span>
                                </button>
                                <button onClick={() => handleShare('share')} className="border-2 border-[#00BCD4] text-[#00BCD4] hover:bg-white px-5 py-2 rounded-[10px] transition-colors flex items-center gap-2">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 14.25C16.642 14.25 15.461 14.983 14.803 16.068L9.47192 13.403C9.64792 12.969 9.75 12.497 9.75 12C9.75 11.503 9.64792 11.031 9.47192 10.597L14.803 7.93201C15.461 9.01601 16.642 9.75 18 9.75C20.067 9.75 21.75 8.068 21.75 6C21.75 3.932 20.067 2.25 18 2.25C15.933 2.25 14.25 3.932 14.25 6C14.25 6.173 14.278 6.33901 14.301 6.50601L8.63599 9.33801C7.95799 8.66601 7.02702 8.25 5.99902 8.25C3.93202 8.25 2.24902 9.932 2.24902 12C2.24902 14.068 3.93202 15.75 5.99902 15.75C7.02602 15.75 7.95799 15.333 8.63599 14.662L14.301 17.494C14.278 17.661 14.25 17.827 14.25 18C14.25 20.068 15.933 21.75 18 21.75C20.067 21.75 21.75 20.068 21.75 18C21.75 15.932 20.067 14.25 18 14.25ZM18 3.75C19.24 3.75 20.25 4.759 20.25 6C20.25 7.241 19.24 8.25 18 8.25C16.76 8.25 15.75 7.241 15.75 6C15.75 4.759 16.76 3.75 18 3.75ZM6 14.25C4.76 14.25 3.75 13.241 3.75 12C3.75 10.759 4.76 9.75 6 9.75C7.24 9.75 8.25 10.759 8.25 12C8.25 13.241 7.24 14.25 6 14.25ZM18 20.25C16.76 20.25 15.75 19.241 15.75 18C15.75 16.759 16.76 15.75 18 15.75C19.24 15.75 20.25 16.759 20.25 18C20.25 19.241 19.24 20.25 18 20.25Z" fill="currentColor" />
                                    </svg>
                                    <span className="font-semibold">{t("More")}</span>
                                </button>
                            </div>

                        </div>

                        <div className="text-center text-sm text-gray-500">
                            {t("Share via your favorite social platform")}
                        </div>

                    </div>
                </div>

                <div className="rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md mb-6">
                    <div className="p-6">
                        <h2 className="text-lg font-bold text-gray-900 mb-4">{t("How It Works")}</h2>
                        <div className="space-y-4">
                            <div className="flex gap-4">
                                <div className="w-10 h-10 rounded-full bg-[--bg-color] text-white flex items-center justify-center font-bold flex-shrink-0">
                                    1
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">{t("Share Your Code")}</h3>
                                    <p className="text-sm text-gray-600">
                                        {t("Share your unique referral code with friends and family")}
                                    </p>
                                </div>
                            </div>

                            <div className="flex gap-4">
                                <div className="w-10 h-10 rounded-full bg-[--bg-color] text-white flex items-center justify-center font-bold flex-shrink-0">
                                    2
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">{t("Friend Signs Up")}</h3>
                                    <p className="text-sm text-gray-600">
                                        {t("signup_credit", { signup_credit: data?.signup_credit })}
                                    </p>
                                </div>
                            </div>

                            <div className="flex gap-4">
                                <div className="w-10 h-10 rounded-full bg-[--bg-color] text-white flex items-center justify-center font-bold flex-shrink-0">
                                    3
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">{t("You Earn Rewards")}</h3>
                                    <p className="text-sm text-gray-600">
                                        {t("refer_credit", { refer_credit: data?.refer_credit })}
                                    </p>
                                </div>
                            </div>

                            <div className="flex gap-4">
                                <div className="w-10 h-10 rounded-full bg-[--bg-color] text-white flex items-center justify-center font-bold flex-shrink-0">
                                    4
                                </div>
                                <div>
                                    <h3 className="font-semibold text-gray-900">{t("Everyone Wins!")}</h3>
                                    <p className="text-sm text-gray-600">
                                        {t("Both you and your friend can use the credits to book rides on ZippyGo!")}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-6 text-center text-sm text-gray-500">
                    <p>{t("* Terms and conditions apply. Rewards will be credited after successful signup.")}</p>
                </div>

            </div>

            <PageLoader loading={loading} />

        </div>
    )
}

export default Referearn